













import { defineComponent, PropType, ref } from "@vue/composition-api";
import { TranslateResult } from "vue-i18n";
import { TagInfo, TagInfoType } from "@scrile/api-provider/dist/api/TagsProvider";
import useUserTags from "@/hooks/useUserTags";
import { $t } from "@/lib/i18nHelpers";
import ModalView from "@/components/ModalView";
import TagsController from "@/components/TagsController";

export default defineComponent({
  name: "SelectUserTagsModal",
  components: { TagsController, ModalView },
  props: {
    value: { type: Boolean, required: true },
    title: { type: String as PropType<TranslateResult>, default: $t("Categories") },
  },
  setup(_, { emit }) {
    const loading = ref(false);
    const { userTags, userTagsUpdateData, userTagsGetData } = useUserTags();
    const getData = async () => {
      try {
        loading.value = true;
        await userTagsGetData();
      } finally {
        loading.value = false;
      }
    };
    const save = async (tags: TagInfo[], cb?: Function) => {
      const tagIds = tags.map(i => i.id);
      try {
        await userTagsUpdateData(tagIds);
        emit("save", tagIds);
      } finally {
        cb && cb();
      }
    };

    getData();

    return {
      userTags,
      save,
      TagInfoType,
    };
  },
});
